import { render, staticRenderFns } from "./meetingView.vue?vue&type=template&id=24c7408c&scoped=true&"
import script from "./meetingView.vue?vue&type=script&lang=js&"
export * from "./meetingView.vue?vue&type=script&lang=js&"
import style0 from "./meetingView.vue?vue&type=style&index=0&id=24c7408c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c7408c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\myProject\\cbi-site-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24c7408c')) {
      api.createRecord('24c7408c', component.options)
    } else {
      api.reload('24c7408c', component.options)
    }
    module.hot.accept("./meetingView.vue?vue&type=template&id=24c7408c&scoped=true&", function () {
      api.rerender('24c7408c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/workplace/components/meetingView.vue"
export default component.exports